'use strict';

angular.module('cloudBillingLegacyFrontend').service('$eaTemplateCachingStrategy', ['$eaConfig', function($eaConfig) {
  var self = this;

  self.processRequest = function(requestConfig) {

    // patch the uri
    if (requestConfig.url.indexOf('?') === -1) {
      requestConfig.url = requestConfig.url + '?v=' + $eaConfig.getConfiguration().deployment.deploymentUUID;
    } else {
      requestConfig.url = requestConfig.url + '&v=' + $eaConfig.getConfiguration().deployment.deploymentUUID;
    }

    // done
    return requestConfig;
  };
}]);
